import * as React from "react";
import { connect } from "react-redux";
import { Route, Redirect, Switch } from "react-router-dom";
import Helmet from "react-helmet";
import * as routes from "../../../utils/routes";
import { Navigation } from "./components/Navigation";
import { WFPortfolioScene, WFSiteScene } from "../Workflow";
import { ComfortPortfolioScene, ComfortZonesScene } from "../Comfort";
import { UtilitiesPortfolioScene } from "../Utilities";
import { getLinkTo } from "../../../utils/routes/navigate";

interface ConnectedProps {
  appReady: boolean;
}

type Props = ConnectedProps;

const mapStateToProps = (state: Insite.AppState): ConnectedProps => ({
  appReady: state.appSetup.appSetupComplete,
});

const Performance: React.FunctionComponent<Props> = ({ appReady }) => {
  if (!appReady) {
    return null;
  }

  return (
    <>
      <Helmet title="Performance" />
      <Navigation />

      {/* Routing Workflow */}
      <Switch>
        <Redirect
          exact
          from={routes.REPORTS.Performance}
          to={getLinkTo(routes.REPORTS.WorkflowPortfolio)}
        />
        <Route
          exact
          path={routes.REPORTS.WorkflowPortfolio}
          component={WFPortfolioScene}
        />
        <Route
          exact
          path={routes.REPORTS.WorkflowSite}
          component={WFSiteScene}
        />
      </Switch>

      {/* Routing Comfort */}
      <Switch>
        <Route
          exact
          path={routes.REPORTS.ComfortPortfolio}
          component={ComfortPortfolioScene}
        />
        <Route
          exact
          path={routes.REPORTS.ComfortZones}
          component={ComfortZonesScene}
        />
      </Switch>

      {/* Routing Utilities */}
      <Switch>
        <Route
          exact
          path={routes.REPORTS.UtilitiesPortfolio}
          component={UtilitiesPortfolioScene}
        />
        <Route
          exact
          path={routes.REPORTS.UtilitiesType}
          component={UtilitiesPortfolioScene}
        />
      </Switch>
    </>
  );
};

export const PerformanceScene = connect(mapStateToProps)(Performance);
